import { logout } from 'auth'
import { TextEditor } from 'components/TextEditor'
import { FieldStack, FormStack } from 'forms/FormStack'
import { useAuthContext } from 'hooks/useAuthContext'
import { UserRole } from 'model'
import {
    IPanelProps,
    Label,
    Panel,
    PanelType,
    PrimaryButton,
    StackItem,
} from 'office-ui-fabric-react'
import * as React from 'react'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Section } from 'views/ProvingDetailsView/Layout'
import {
    useAddSignatureMutation,
    useGenerateMyCalendarLinkMutation,
} from './UserSettings.generated'

export const UserSettings: React.FunctionComponent<IPanelProps> = (props) => {
  const { t } = useTranslation()
  const auth = useAuthContext()
  const [generateCalendarLink] = useGenerateMyCalendarLinkMutation({
    onCompleted: () => {
      auth.refetch!()
    },
  })
  const [signatureState, setSignature] = useState(
    auth.user && auth.user.signature ? auth.user.signature : ''
  )
  const [addSignature] = useAddSignatureMutation({
    onCompleted: () => {
      auth.refetch!()
    },
  })

  const isMaintenanceHead = auth.hasUserRole(UserRole.Maintenancehead)
  const isReader = auth.hasUserRole(UserRole.Reader)
  const isUser = auth.hasUserRole(UserRole.User)
  const isProvingCreator = auth.hasUserRole(UserRole.ProvingCreator)

  const canEditSignature = () => {
    if (isMaintenanceHead || isReader || isUser || isProvingCreator) {
      return false
    } else {
      return true
    }
  }

  return (
    <Panel type={PanelType.medium} {...props}>
      <Section label="Kalendar">
        <Label>{t('field.calendar.label')}</Label>
        <p>{t('field.calendar.information')}</p>
        <p>{(auth.user && auth.user.calendarLink) || '-'}</p>
        <PrimaryButton
          text="Generate"
          onClick={async () => await generateCalendarLink()}
        />
      </Section>

      {canEditSignature() === true && (
        <Section label="Signatur">
          <FormStack>
            <Label>Hier können Sie Ihre E-Mail Signatur konfigurieren:</Label>
            <FieldStack>
              <TextEditor
                value={(auth.user && auth.user.signature) || ''}
                onChange={(value) => {
                  setSignature(value)
                }}
              />
            </FieldStack>
            <StackItem>
              <PrimaryButton
                text="Signatur speichern"
                onClick={async () =>
                  await addSignature({
                    variables: {
                      input: signatureState,
                    },
                  })
                }
              />
            </StackItem>
          </FormStack>
        </Section>
      )}
      <PrimaryButton text="Ausloggen" onClick={() => logout()} />
    </Panel>
  )
}
